import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Col, Row, Card, Form, Button, Spinner, Container, Navbar, Nav, InputGroup} from 'react-bootstrap';

const FormaDeEnvio = ({storage}) => {
  const [endereco, setEndereco] = useState(null);
  
  useEffect(()=>{
    const buscarSacola = async () => {
        try {
          const response = await storage.buscar('sacola');
          if (response && response.length) {
            const sacola = response[0] || {};
            setEndereco(sacola.endereco);
          }
        } catch (err) {
          console.error('Erro ao buscar sacola:', err);
        }
    };
    buscarSacola();
  }, [setEndereco])
  
  
  return (
    <>
      <div className="border rounded p-2 mb-3">
              <Row className="align-items-center">
                <Col xs="auto">
                  {endereco?.is_entrega?(
                    <i class="fa-solid fa-person-biking fs-1"></i>
                  ):(
                    <i className="bi bi-person-walking fs-1"></i>
                  )}
                </Col>
                <Col>
                  <Row>
                    <Col>{endereco?.is_entrega?"Entrega":"Retirada"} em {endereco?.is_entrega?endereco?.duracao||`0-0 min`:`0-0 min`}</Col>
                    <Col xs={12}>{parseFloat(endereco?.taxa||0)>0 && endereco?.is_entrega?parseFloat(endereco?.taxa||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }):"Grátis"}</Col>
                  </Row>
                </Col>
                <Col xs="auto">
                  <Link to="?p=endereco">Trocar</Link>
                </Col>
              </Row>
            </div>
    </>
  )
}

export default FormaDeEnvio